import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getPathLanguage, withLanguagePrefix } from "@/lib/i18n";

const LocalizedLink = React.forwardRef(({ to, ...props }, ref) => {
  const location = useLocation();
  const lang = getPathLanguage(location.pathname);

  let localizedTo = to;
  if (typeof to === "string") {
    localizedTo = to.startsWith("/admin") ? to : withLanguagePrefix(to, lang);
  } else if (to?.pathname) {
    localizedTo = {
      ...to,
      pathname: to.pathname?.startsWith("/admin") ? to.pathname : withLanguagePrefix(to.pathname, lang),
    };
  }

  return <Link ref={ref} to={localizedTo} {...props} />;
});

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
